import { render, staticRenderFns } from "./StaffTasks.vue?vue&type=template&id=4543c482&scoped=true"
import script from "./StaffTasks.vue?vue&type=script&lang=js"
export * from "./StaffTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543c482",
  null
  
)

export default component.exports